/*eslint-disable eqeqeq*/
import React from 'react';
import AreasList from '../../component/componentAreas/Areaslist';
// import {data} from './data'
import * as APIController from '../../../../api/APIController';
// import * as APIController from '../../../../src/api/APIController';
import Notification from '../../../../shared/components/notification/notification';
class AdminAreasContainer extends React.Component {

    state = {
        currentPage: 1,
        count: 0,
        list: [],
        rowsPerPage: 10,
        rowsPerPageOptions: [10, 25, 50, 'All'],
        from: 0,
        to: 10,
        progress: true,
        message: '',
        showNotification: false,
        isError: false,
        showMessage: this.props.history.location.state != null && this.props.history.location.state.showMessage
    }
    componentDidMount() {
        this.wsGetAreas(this.state.currentPage, this.state.rowsPerPage, this.state.from, this.state.to);
        this.state.showMessage != '' && this.handleNotification(this.state.showMessage)
        this.props.history.replace('/resource/areas', null);
    }
    handlebind() {
        this.wsGetAreas(this.state.currentPage, this.state.rowsPerPage)
    }
    wsGetAreas(CurrentPage, RecordPerPage, from, to, AreaName, ShortCodeName, IsActive) {
        this.setState({ progress: true, });
        APIController.GetAreas(CurrentPage, RecordPerPage, AreaName, ShortCodeName, IsActive)
            .then((response) => {
                if (response.object.status == 0 && response.object.data.length != 0) {
                    this.setState({
                        to: isNaN(to) ? 1000000 : to,
                        from: from,
                        count: response.object.data[0].MaxRows,
                        list: response.object.data,
                        progress: false,
                    })
                }
                else if (response.object.message && response.object.message.length > 0) {
                    // ToastsStore.warning(response.error.message)
                } else { this.setState({ list: [], progress: false }) }
            })
    }
    render() {
        return (
            <>
                <Notification
                    isError={this.state.isError}
                    message={this.state.message}
                    showNotification={this.state.showNotification}
                    clearNotification={this.handleClearNotification}
                    closeNotification={this.handleClearNotification}
                />
                <section className="content-right-main">
                    <div className="button-field button-field-country">
                        <button onClick={() => {
                            this.props.history.push({
                                pathname: '/admin/areas/add',
                                state: { areaIdEdit: '0', areaNameEdit: '', ShortcodeEdit: '', areaActiveEdit: 1, }
                            })
                        }}>+ Add Area</button>
                    </div>
                    <AreasList {...this.state}
                        history={this.props.history}
                        handlebind={this.handlebind.bind(this)}
                        handleChangeRowsPerPage={this.handleRowsPerPageChange}
                        handleChangePage={this.handlePageChange}
                        applyFilter={this.handleApplyFilter}
                        handleNotification={this.handleNotification}
                    />
                </section>
            </>
        )
    }

    handleRowsPerPageChange = (value, NameTest, ShortCodeText, IsActive) => {
        let from = 0
        let to = value;
        this.setState({ progress: true, rowsPerPage: value, currentPage: 1, to: to, from: from })
        this.wsGetAreas(isNaN(value) ? '' : this.state.currentPage, isNaN(value) ? 1000000 : value, from, to, NameTest, ShortCodeText, IsActive);
    }

    handlePageChange = (values, NameTest, ShortCodeText, IsActive) => {
        let from = values === 1 ? 0 * this.state.rowsPerPage : (values - 1) * this.state.rowsPerPage
        let to = values === 1 ? this.state.rowsPerPage : (from + this.state.rowsPerPage);
        this.setState({ currentPage: Number(values) })
        this.wsGetAreas(Number(values), this.state.rowsPerPage, from, to, NameTest, ShortCodeText, IsActive);
    }

    handleApplyFilter = (NameTest, ShortCodeText, IsActive) => {
        this.wsGetAreas(this.state.currentPage, this.state.rowsPerPage, this.state.from, this.state.to, NameTest, ShortCodeText, IsActive)
    }

    handleNotification = (message, isError) => {
        this.setState({
            message: message,
            showNotification: true,
            isError: isError
        })

        setTimeout(() => {
            this.handleClearNotification();
        }, 4000)
    }

    handleClearNotification = () => {
        this.setState({
            message: '',
            showNotification: false,
            isError: false
        })
    }
}

export default AdminAreasContainer;